
      const metas = import.meta.glob("./src/games/*/meta.ts", { eager: true });
      const el = document.getElementById("games");
      // Live: link each game's own address (<id>.enjoyment.app), not a path under whatever host serves the
      // catalog; local dev and previews keep relative paths.
      const live = location.hostname === "enjoyment.app" || location.hostname.endsWith(".enjoyment.app");
      for (const m of Object.values(metas).map((x) => x.meta).sort((a, b) => a.name.localeCompare(b.name, "tr"))) {
        const a = document.createElement("a");
        a.className = "card";
        a.href = live ? `https://${m.id}.enjoyment.app/` : `/${m.id}/`;
        a.style.setProperty("--a", m.accent);
        a.innerHTML = `<b></b><span></span><small></small>`;
        a.querySelector("b").textContent = m.name;
        a.querySelector("span").textContent = m.tagline;
        a.querySelector("small").textContent = `${m.inspiredBy} × ${m.secondLayer}`;
        el.appendChild(a);
      }
      if (!el.children.length) el.textContent = "Henüz oyun yok.";
    